module.exports = __webpack_public_path__ + "img/ph.9124b268.svg";